<template>
    <div>
        <SkeletonBase
            class="hidden md:block"
            :content="1"
            has-divided
        />
        <SkeletonBase
            class="md:hidden"
            :content="2"
            has-divided
        />
        <SkeletonBase
            class="hidden md:block"
            has-title
            :table="2"
            has-button
        />
        <SkeletonBase
            class="md:hidden"
            has-title
            :content="3"
            has-button
        />
    </div>
</template>

<script>
import SkeletonBase from '@/components/skeletons/SkeletonBase.vue';

export default {
    components: {
        SkeletonBase
    },
};
</script>
